export default __webpack_public_path__ + "static/media/icon-ui-content.64668789.svg";